import * as React from "react"
import type { SVGProps } from "react"
const SvgLongArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7.85 13.14H19a1 1 0 0 0 .71-.29 1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H7.85l2.85-2.85q.3-.3.29-.7a1 1 0 0 0-1-1.01 1 1 0 0 0-.72.29L4.7 11.44a1 1 0 0 0-.22.33 1 1 0 0 0-.06.37q0 .2.06.37a1 1 0 0 0 .21.33l4.58 4.57q.3.3.71.29a1 1 0 0 0 1-1.01 1 1 0 0 0-.28-.7z" />
  </svg>
)
export default SvgLongArrowLeft
